import { buildUserOption } from '@witmetrics/unison-core';
import { searchByLabel } from '@witmetrics/utils/arrays';
import { isBlank } from '@witmetrics/utils/strings';
import { getRoundedDateTime } from '@witmetrics/utils/time';
import { API } from '@/api';

export const classes = {
  dialog: 'w-[98vw] max-w-[450px] min-w-[350px]',
  body: 'w-full max-h-[80vh] min-h-[100px] pt-2 pb-12 overflow-auto',
  input: 'w-full my-4',
};

export function getInitialDueAt(dueAt?: string) {
  const base = dueAt ? new Date(dueAt) : new Date();
  return new Date(getRoundedDateTime(base.toISOString()));
}

export function validateFields({
  dueAt,
  assignedTo,
  description,
}: {
  dueAt?: string | null;
  assignedTo: { value: number; label: string } | null;
  description: string;
}) {
  const invalidFields = [];
  if (!dueAt) invalidFields.push('dueAt');
  if (isBlank(description)) invalidFields.push('description');
  if (!assignedTo) invalidFields.push('assignedTo');
  return invalidFields;
}

export async function fetchPracticeUsers(practiceId: number) {
  const users = await API.Practices.fetchPracticeUsers(practiceId, {
    filters: [],
    pagination: { page: 1, pageSize: 100 },
  });
  return users.results.map(({ user }) => buildUserOption(user));
}

export async function fetchTaskTemplates(practiceId: number) {
  const response = await API.Practices.fetchPracticeTaskTemplates(practiceId, {
    filters: [],
    pagination: { page: 1, pageSize: 100 },
  });
  return response.results;
}

export async function searchAssignedTo(
  searchQuery: string,
  practiceUsers: { value: number; label: string }[]
) {
  return searchByLabel(practiceUsers, searchQuery);
}
